// @flow
import { RESORT_MEETING_ROOM_INFO } from 'Client/cms/toolkit/constants';
import { ProductMeetingRoomInfoLine } from 'Components/lines/product-meeting-room-info-line/ProductMeetingRoomInfoLine';
import { productMeetingRoomInfoResolver } from './productMeetingRoomInfo.resolver';

export const productMeetingRoomInfoDescriptor = {
  name: RESORT_MEETING_ROOM_INFO,
  component: ProductMeetingRoomInfoLine,
  resolve: productMeetingRoomInfoResolver.resolve,
};
